
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Upload from '@/components/UploadImage'
import CPosition from '@/components/Position'
export default {
name: 'Order',
directives: {
TransferDom
},
components: {
Cell,
Group,
Timeline,
TimelineItem,
XButton,
Flexbox,
FlexboxItem,
Upload,
XTextarea,
CPosition,
Confirm
},
data() {
return {
ID: '',
MEMO: '',
isComplete: false,
uploadParams: {},
color: 'red',
order: {},
orderFiles: [],
demageFiles: [],
hasOrderImg: false, // 是否已经提交提货交接单
hasDemageImg: false, // 是否已经提交破损交接单
isSubmit: false,
showConfirm: false,
confirmTitle: '',
stepForm: {}
}
},
computed: {
position() {
return this.$store.getters.getPosition
}
},
created() {
this.ID = this.$route.query.ID || ''
if (process.env.NODE_ENV != 'development' && this.$store.state.app.roleid != 0) {
this.$router.replace({
path: './th/order?ID=' + this.ID
})
return;
}
this.uploadParams = {
SUBDIR: this.$config.SUBDIR.th
}
this.loadData()
this.$store.dispatch('baiduPosition')
},
methods: {
loadData() {
let _this = this
_this.$vux.loading.show()
let url = 'TH.ashx?action=Form_Load'
this.$post(url, {
ID: this.ID
}).then(
response => {
_this.order = response
_this.isComplete = _this.order.STATUS == 4 || (_this.order.IS_ONECAR == 1 && _this.order.STATUS == 3) ? true : false
_this.color = _this.isComplete ? '#04BE02' : 'red'

if (_this.isComplete) {
_this.toPsd()
return
}
if (_this.isComplete) _this.MEMO = _this.order.TH_MEMO
_this.$vux.loading.hide()
_this.getOrderFiles()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
},
getOrderFiles() {
let _this = this;
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_order, res => {
if (res.length > 0) _this.hasOrderImg = true
_this.orderFiles = res
});
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_demage, res => {
if (res.length > 0) _this.hasDemageImg = true
_this.demageFiles = res
});
},
submitOrderFiles(file) {
let _this = this;
_this.$comapi.SaveWebFile(this.order.WORKNO, _this.$config.F_SRC.th_order, file, function(res) {
if (res) _this.hasOrderImg = true
})
},
submitDemageFiles(file) {
let _this = this;
_this.$comapi.SaveWebFile(this.order.WORKNO, _this.$config.F_SRC.th_demage, file, function(res) {
if (res) _this.hasDemageImg = true
})
},
handleStep(STATUS, STATUS_NAME) {
const sPara = {
TH_MEMO: this.MEMO,
ID: this.order.ID,
STATUS: STATUS,
SLAT: this.position.lat,
SLNG: this.position.lng,
ADDR: this.position.addr
};
var url = "TH.ashx?action=TH_Update_Status_DT";
if (STATUS == 3) {
sPara.DT_FIELD = 'DT_OUT';
if (this.order.IS_ONECAR == 1) {
url = 'TH.ashx?action=TH_TO_TRANS';
sPara.STATUS = 4;
sPara.TH_STATUS = 3;
}
}
else if (STATUS == 2) sPara.DT_FIELD = 'DT_TH';
else if (STATUS == 5) sPara.DT_FIELD = 'DT_TH_OK';
else if (STATUS == 4) sPara.DT_FIELD = 'DT_CQHUB_ARRIVE';
sPara.url = url
this.confirmTitle = STATUS_NAME
this.stepForm = sPara
this.showConfirm = true
},
onStepConfirm() {
if (this.isSubmit) return
this.isSubmit = true
this.$post(this.stepForm.url, this.stepForm).then(res => {
this.$toast.success('操作成功')
setTimeout(() => {
this.isSubmit = false
this.showConfirm = false
this.loadData()

}, 1000);
}).catch(res => {
setTimeout(function() {
this.isSubmit = false
this.showConfirm = false
}, 3000)
})
},
toComplete() {
let _this = this;
if (!this.hasOrderImg) {
this.$toast.text('请先上传提货交接单')
return
}
if (this.isSubmit) return
this.isSubmit = true
let param = {
ID: _this.ID,
TH_MEMO: _this.MEMO,
SLAT: _this.position.lat,
SLNG: _this.position.lng,
ADDR: _this.position.addr,
ALARM_INFO: JSON.stringify({
MSG_CODE: "TH_DONE",
BASE_ID: 21
})
};
_this.$post('TH.ashx?action=Update_Status2', param).then(res => {
_this.$toast.success('操作成功')
setTimeout(() => {
_this.$route.back()
}, 1000);
}).catch(res => {
setTimeout(function() {
_this.isSubmit = false
}, 3000)

})
},
toPsd() {
if (this.order.TRANS_INFO && this.order.TRANS_INFO.ID) {
this.$router.push('./psd?ID=' + this.order.TRANS_INFO.ID)
}
},
toAbnormal() {
this.$router.push({
path: './abnormal?TYPE=0&ID=' + this.ID
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/Acer/Thd.vue